import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />'
})
export class AppComponent {

  constructor(themeService: ThemeService) {
    themeService.loadTenantTheme();
  }
}
